// extracted by mini-css-extract-plugin
module.exports = {"errorPointsContainer":"styles_errorPointsContainer__3dEOj","resultContainer":"styles_resultContainer__O5JPt"};